import "./css/MyVc.css"  
import misionImg from "../img/My.png"
import visionImg from "../img/yV.png"

function MisionVisionContenido() {
  return (
    <section id="Myvv" className="mision-vision-contenido-container">
      <div className="mision-vision-cards">
        {/* Contenedor para la tarjeta de Visión - Alineado a la izquierda */}
        <div className="card-container left-container">
          <div className="vision-card">
            <div className="icon-circle vision-icon">
              <img
                src={visionImg || "/placeholder.svg"}
                alt="Ícono de Visión"
                onError={(e) => {
                  console.error("Error al cargar la imagen de visión")
                  e.target.src = "https://via.placeholder.com/150?text=Vision"
                }}
              />
            </div>
            <div className="card-content">
              <h3>VISIÓN</h3>
              <p>
                Ser una empresa con vocación de servicio, responsabilidad, eficiente y ágil que constituya una
                herramienta de éxito y satisfacción para nuestros clientes.
              </p>
            </div>
          </div>
        </div>

        {/* Contenedor para la tarjeta de Misión - Alineado a la derecha */}
        <div className="card-container right-container">
          <div className="mision-card">
            <div className="card-content">
              <h3>MISIÓN</h3>
              <p>
                Realizar nuestro trabajo con prontitud utilizando lo mejor de nuestro personal humano, como tecnológico,
                ofreciendo de esta forma la mejor de las opciones de servicio en el ramo de gestión aduanal.
              </p>
            </div>
            <div className="icon-circle mision-icon">
              <img
                src={misionImg || "/placeholder.svg"}
                alt="Ícono de Misión"
                onError={(e) => {
                  console.error("Error al cargar la imagen de misión")
                  e.target.src = "https://via.placeholder.com/150?text=Mision"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MisionVisionContenido
